module.exports = __webpack_public_path__ + "static/media/calendar.f22ea9be.svg";